import { ElementType, useElementIndex } from '../../contexts/elementIndex';

export const useCurrentConditionIndex = (): number | undefined =>
  useElementIndex(ElementType.Condition);
